import { combineReducers } from "redux-immutable";

import {
  CrudConfig,
  makeCrudStateReducer
} from "seneca-common/utils/apiStates";

import queryCourseActionTypes from "../action-types";
import { coursesQueryCrudStateConfig } from "../consts";
import CoursesQuery from "../models/CoursesQuery";
import { makeReducer as makeAggregationsReducer } from "./state/aggregations";
import { makeReducer as makeCoursesReducer } from "./state/courses";

export function makeReducer(
  actionTypes: typeof queryCourseActionTypes,
  crudStateConfig: CrudConfig
) {
  return combineReducers(
    {
      courses: makeCoursesReducer(actionTypes),
      aggregations: makeAggregationsReducer(actionTypes),
      meta: makeCrudStateReducer(crudStateConfig)
    } as any,
    () => new CoursesQuery() as any
  );
}

export default makeReducer(queryCourseActionTypes, coursesQueryCrudStateConfig);
